import React from 'react';
import { Tooltip as ReactTooltip } from 'react-bootstrap';

function Tooltip(props) {
  return (
    <ReactTooltip {...props}>
      <div
        style={
          props.container_style
            ? { ...props.container_style }
            : { padding: 10, textAlign: 'center' }
        }
      >
        {Array.isArray(props.data)
          ? props.data.map((item, i) => (
              <p style={{ margin: 5 }} key={i}>
                {item.email ? item.email : item}
              </p>
            ))
          : props.data}
      </div>
    </ReactTooltip>
  );
}
export default Tooltip;
